var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "huge-icon/education/outline/graduation cap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0007 14.0631V18.7298C21.0007 20.6628 19.4336 22.2298 17.5007 22.2298H10.5007C8.56765 22.2298 7.00065 20.6628 7.00065 18.7298V14.0631M12.9572 6.41821L2.33398 11.7298L12.9572 17.0414C13.6141 17.3698 14.3873 17.3698 15.0442 17.0414L25.6673 11.7298L15.0442 6.41821C14.3873 6.08976 13.6141 6.08976 12.9572 6.41821Z",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1499",
    d: "M25.666 11.7305V18.7305",
    stroke: "#A461D8",
    strokeWidth: 1.65833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education-icon.e785276c804f13647fa881def1cba6e5.svg";
export { ForwardRef as ReactComponent };